import type { ReactNode } from "react";
import { C } from "../tokens";

interface Props {
  label: string;
  value: ReactNode;
  sublabel?: ReactNode;
  color?: string;
  icon?: ReactNode;
  trend?: "up" | "down" | "flat";
  trendValue?: string;
  small?: boolean;
  onClick?: () => void;
}

/** The little stat tile used across dashboards. */
export function Stat({
  label, value, sublabel, color = C.text, icon, trend, trendValue, small = false, onClick,
}: Props) {
  const trendColor =
    trend === "up" ? C.green : trend === "down" ? C.red : C.textMuted;
  return (
    <div
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(e) => { if (onClick && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); onClick(); } }}
      onMouseEnter={(e) => { if (onClick) (e.currentTarget as HTMLDivElement).style.borderColor = C.borderBright; }}
      onMouseLeave={(e) => { if (onClick) (e.currentTarget as HTMLDivElement).style.borderColor = C.border; }}
      style={{
        background: C.surface,
        border: `1px solid ${C.border}`,
        borderRadius: 14,
        padding: small ? 10 : 14,
        display: "flex",
        flexDirection: "column",
        gap: 4,
        minWidth: 0,
        cursor: onClick ? "pointer" : "default",
        transition: "border-color 0.15s",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 6, color: C.textMuted, fontSize: small ? 9 : 10, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 700 }}>
        {icon}
        <span>{label}</span>
      </div>
      <div style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
        <div style={{ color, fontSize: small ? 18 : 22, fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>
          {value}
        </div>
        {trend && trendValue && (
          <span style={{ color: trendColor, fontSize: 10, fontWeight: 700 }}>
            {trend === "up" ? "▲" : trend === "down" ? "▼" : "–"} {trendValue}
          </span>
        )}
      </div>
      {sublabel && (
        <div style={{ color: C.textMuted, fontSize: small ? 9 : 10 }}>
          {sublabel}
        </div>
      )}
    </div>
  );
}
